import type { ReactNode } from 'react';

export type A11yTextType = 'ariaHidden' | 'visuallyHiddenText';

const A11yTextWrapper = (props: {
    a11yText?: string;
    a11yType: A11yTextType;
    className?: string;
    containerClassName?: string;
    children: ReactNode;
}) => {
    return (
        <div className={`u-posRelative ${props.containerClassName || ''}`}>
            <div
                aria-hidden={props.a11yText || props.a11yType === 'ariaHidden' ? true : undefined}
                className={props.className}
            >
                {props.children}
            </div>
            {props.a11yText && props.a11yType === 'visuallyHiddenText' && (
                <p className="u-hiddenVisuallyOutlined">{props.a11yText}</p>
            )}
        </div>
    );
};

export default A11yTextWrapper;
